import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { IAlertComponent } from "@front/m19-ui";
import { TargetingLimit } from "@m19-board/strategies/target-utils";

@Component({
  selector: "app-target-limit-warning",
  templateUrl: "./target-limit-warning.component.html",
  imports: [IAlertComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TargetLimitWarningComponent {
  readonly targetLimit = input<TargetingLimit>();
  readonly tooManyTargets = computed(() => this.targetLimit()?.tooManyTargets() ?? false);
  readonly description = computed(() => this.targetLimit()?.formatErrorMessage() ?? "");
}
